import React, { useEffect, useState } from "react";
import { BsArrowLeftCircleFill, BsArrowRightCircleFill } from "react-icons/bs";

export const Carousel = (props) => {
  const { data, index } = props;
  const [slide, setSlide] = useState(index);
  const [isZoomed, setIsZoomed] = useState(false);

  useEffect(() => {
    setSlide(index);
  }, [index]);

  const nextSlide = () => {
    setSlide(slide === data.length - 1 ? 0 : slide + 1);
  };

  const prevSlide = () => {
    setSlide(slide === 0 ? data.length - 1 : slide - 1);
  };

  const toggleZoom = () => {
    setIsZoomed((prev) => !prev);
  };

  return (
    <div className="carousel">
      {slide - 1 >= 0 && (
        <BsArrowLeftCircleFill
          onClick={prevSlide}
          className="arrow arrow-left"
        />
      )}
      {data.map((item, idx) => {
        return (
          <div
            className={` ${slide === idx ? "slide" : "slide slide-hidden"}
              ${isZoomed ? "zoomed" : ""}
              zoom-toggle-container`}
            onClick={toggleZoom}
          >
            <img src={item.image} key={idx} className={`zoom-toggle-image `} />
          </div>
        );
      })}
      {slide + 1 < data.length && (
        <BsArrowRightCircleFill
          onClick={nextSlide}
          className="arrow arrow-right"
        />
      )}
      <span className="indicators">
        {data.map((_, idx) => {
          return (
            <button
              key={idx}
              className={
                slide === idx ? "indicator" : "indicator indicator-inactive"
              }
              onClick={() => setSlide(idx)}
            ></button>
          );
        })}
      </span>
    </div>
  );
};
